import { useState } from "react";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import img from "../../assets/images/background/13.jpg";
import { useTranslation } from "react-i18next";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";

function FindUs() {
  const { t } = useTranslation();

  const cexEyebrowRef = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const cexHeadRef    = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const cexBulletsRef = useAnimateCssStagger("animate__fadeInLeft", 80,  0.08);
  const cexCardsRef   = useAnimateCssStagger("animate__fadeInUp",   90,  0.08);
  const cexFormRef    = useAnimateCss("animate__fadeInRight", 0,   0.1,  800);

  const ctLabelRef  = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const ctHeadRef   = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const ctSocialRef = useAnimateCss("animate__fadeInUp",   200, 0.15);
  const ctMapsRef   = useAnimateCssStagger("animate__fadeInUp", 120, 0.1);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `mailto:info@almadina-steel.com?subject=Inquiry from ${encodeURIComponent(form.name)}&body=${encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\n\n${form.message}`)}`;
  };

  return (
    <>
      <MainHeader />
      <PageHeader image={img} title={t("Contact Us")} />

      {/* ── Expert Guidance section ── */}
      <section className="cex-section">
        <div className="container">
          <div className="row g-5 align-items-start">
            {/* LEFT */}
            <div className="col-lg-6">
              <span className="cex-eyebrow" ref={cexEyebrowRef as any}>{t("cex-label")}</span>
              <h2 className="cex-heading" ref={cexHeadRef as any}>{t("cex-heading")}</h2>
              <div className="cex-bullets" ref={cexBulletsRef as any}>
                {["cex-bullet-1", "cex-bullet-2", "cex-bullet-3"].map((k) => (
                  <span key={k}>
                    <i className="bi bi-check2" /> {t(k)}
                  </span>
                ))}
              </div>

              <div className="row g-3 mt-1" ref={cexCardsRef as any}>
                {/* TELEPHONE */}
                <div className="col-sm-6 col-12">
                  <div className="cex-card">
                    <i className="bi bi-telephone cex-card__watermark" />
                    <p className="cex-card__title">{t("cex-tel-label")}</p>
                    <div className="cex-card__row">
                      <div className="cex-card__numbers">
                        <span>+20225270107</span>
                        <span>+20225270108</span>
                        <span>+20225270105</span>
                        <span>+2025253716</span>
                      </div>
                      <div className="cex-card__alt">
                        <p className="cex-card__alt-label">
                          {t("cex-tel-phone-label")}
                        </p>
                        <span>01122222385</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* FACTORY + HQ */}
                <div className="col-sm-6 col-12">
                  <div className="cex-card">
                    <i className="bi bi-geo-alt cex-card__watermark" />
                    <p className="cex-card__title">{t("cex-factory-label")}</p>
                    <p className="cex-card__value">
                      3rd Ind. Zone, 10th of Ramadan, A2 Piece 1,2
                    </p>
                    <p className="cex-card__title mt-2">{t("cex-hq-label")}</p>
                    <p className="cex-card__value">48 St 105, Maadi</p>
                  </div>
                </div>

                {/* EMAIL */}
                <div className="col-sm-6 col-12">
                  <div className="cex-card">
                    <i className="bi bi-envelope cex-card__watermark" />
                    <p className="cex-card__title">{t("cex-email-label")}</p>
                    <p className="cex-card__value">info@almadina-steel.com</p>
                  </div>
                </div>

                {/* WORKING HOURS */}
                <div className="col-sm-6 col-12">
                  <div className="cex-card">
                    <i className="bi bi-clock cex-card__watermark" />
                    <p className="cex-card__title">{t("cex-hours-label")}</p>
                    <p className="cex-card__value">09:00 am – 05:00 pm</p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT — form */}
            <div className="col-lg-6" ref={cexFormRef as any}>
              <div className="cex-form-card">
                <form className="cex-form" onSubmit={handleSubmit}>
                  <div className="cex-field">
                    <input
                      className="cex-input"
                      type="text"
                      name="name"
                      placeholder={t("cex-form-name")}
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                    <span className="cex-input-line" />
                  </div>
                  <div className="cex-field">
                    <input
                      className="cex-input"
                      type="email"
                      name="email"
                      placeholder={t("cex-form-email")}
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                    <span className="cex-input-line" />
                  </div>
                  <div className="cex-field">
                    <input
                      className="cex-input"
                      type="tel"
                      name="phone"
                      placeholder={t("cex-form-phone")}
                      value={form.phone}
                      onChange={handleChange}
                    />
                    <span className="cex-input-line" />
                  </div>
                  <div className="cex-field">
                    <textarea
                      className="cex-input cex-textarea"
                      name="message"
                      placeholder={t("cex-form-message")}
                      value={form.message}
                      onChange={handleChange}
                      rows={4}
                    />
                    <span className="cex-input-line" />
                  </div>
                  <button type="submit" className="cex-submit">
                    {t("cex-form-send")} <i className="bi bi-arrow-right" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="row g-5">
            {/* Contact info column */}
            <div className="col-lg-5">
              <span className="page-section-label" ref={ctLabelRef as any}>{t("Find Us")}</span>
              <h2 className="inner-page-heading" ref={ctHeadRef as any}>{t("Get In Touch")}</h2>
              {/* 
              <div className="contact-info-block">
                {/* Phone */}
              {/*
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="bi bi-telephone-fill" />
                  </div>
                  <div>
                    <span className="contact-info-label">Call Us</span>
                    <p className="contact-info-value">
                      01122222385 – 025253716<br />
                      0225270105 – 0225270107 – 0225270108
                    </p>
                  </div>
                </div>
                  */}
              {/* Hours */}

              {/*<div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="bi bi-clock-fill" />
                  </div>
                  <div>
                    <span className="contact-info-label">Working Hours</span>
                    <p className="contact-info-value">09:00 am – 05:00 pm</p>
                  </div>
                </div>
                  */}
              {/* Email */}
              {/*
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="bi bi-envelope-fill" />
                  </div>
                  <div>
                    <span className="contact-info-label">Email Us</span>
                    <p className="contact-info-value">info@almadina-steel.com</p>
                  </div>
                </div>
                */}
              {/* HQ */}
              {/*
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="bi bi-geo-alt-fill" />
                  </div>
                  <div>
                    <span className="contact-info-label">Headquarters</span>
                    <p className="contact-info-value">
                      {t("H.Q:48 Street 105, Maadi Al Khabiri Al Gharbeyah, Al Maadi Cairo")}
                    </p>
                  </div>
                </div>
                */}
              {/* Factory */}
              {/*
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="bi bi-building-fill" />
                  </div>
                  <div>
                    <span className="contact-info-label">Factory</span>
                    <p className="contact-info-value">
                      {t("Plants 10th of Ramdan,third Industrial Zone - A2 Piece 1,2")}
                    </p>
                  </div>
                </div>
              </div>
                */}

              {/* Social */}
              <div ref={ctSocialRef as any}>
                <p
                  style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: "12px",
                    fontWeight: 700,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    color: "var(--color-primary, #EF381B)",
                    marginBottom: "12px",
                  }}
                >
                  {t("Follow on")}
                </p>
                <div className="contact-social-row">
                  <a
                    href="https://www.facebook.com/MDS2030/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                    aria-label="Facebook"
                  >
                    <i className="bi bi-facebook" />
                  </a>
                  <a
                    href="https://www.instagram.com/almadinasteel/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                    aria-label="Instagram"
                  >
                    <i className="bi bi-instagram" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/almadinasteel"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                    aria-label="LinkedIn"
                  >
                    <i className="bi bi-linkedin" />
                  </a>
                  <a
                    href="https://www.youtube.com/@almadinasteel"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                    aria-label="YouTube"
                  >
                    <i className="bi bi-youtube" />
                  </a>
                </div>
              </div>
            </div>

            {/* Maps column */}
            <div className="col-lg-7">
              <div className="d-flex flex-column gap-4" ref={ctMapsRef as any}>
                <div>
                  <p className="contact-map-label">{t("HeadQuarter")}</p>
                  <div className="contact-map-wrap">
                    <iframe
                      title="headquarter"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.4640121979933!2d31.248381110358913!3d29.966092122175677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14584792ec835fcf%3A0xfa530ec18aa0ed87!2z2YXYrNmF2YjYudipINin2YTZhdiv2YrZitmG2Kkg2YTZhNi12YTYqA!5e0!3m2!1sen!2seg!4v1700916696452!5m2!1sen!2seg"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div>
                  <p className="contact-map-label">{t("Factory")}</p>
                  <div className="contact-map-wrap">
                    <iframe
                      title="factory"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.134044994368!2d31.792652775563283!3d30.29024537480082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1457fd5b14e6c2b5%3A0x51dabd38a61fd905!2z2YXYtdmG2Lkg2KfZhNmF2K_ZitmG2Kkg2YTZhNi12YTYqA!5e0!3m2!1sen!2seg!4v1710077798761!5m2!1sen!2seg"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default FindUs;
